export const ErrorMessage = (props: { errorMessage: string }) => (
  <div style={{ color: 'red' }}>{props.errorMessage}</div>
);
